import { combineReducers } from 'redux'
import peerAlerts from './peerAlerts.reducer'
import list from './peers.reducer'

// We combine the reducers here so that they can be left split apart above
const watchListReducer = combineReducers({ list, peerAlerts })

export default watchListReducer
